module.exports = __webpack_public_path__ + "static/img/6.bc78515.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/eng/6.png
// module id = tvfw
// module chunks = 0